import { render, staticRenderFns } from "./RegistarLock.vue?vue&type=template&id=63700777&"
import script from "./RegistarLock.vue?vue&type=script&lang=js&"
export * from "./RegistarLock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63700777')) {
      api.createRecord('63700777', component.options)
    } else {
      api.reload('63700777', component.options)
    }
    module.hot.accept("./RegistarLock.vue?vue&type=template&id=63700777&", function () {
      api.rerender('63700777', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Domains/DomainOptions/RegistarLock.vue"
export default component.exports